import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';

const ADDRESS_LINES = [
  'Headlands House',
  '1 Kings Court',
  'Kettering Parkway',
  'Kettering',
  'Northamptonshire',
  'NN15 6WJ',
];

export const LegalStrip = () => (
  <div data-testid="legal-strip" className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[13px] text-[var(--muted)]">
    <span className="inline-flex items-center gap-1.5 uppercase tracking-[0.14em] text-[11px] font-semibold">
      <ShieldCheck size={14} strokeWidth={2} className="text-[var(--silver)]" /> UK GDPR
    </span>
    <Link to="/privacy" className="underline underline-offset-4 hover:text-white transition-colors">Privacy Notice</Link>
    <Link to="/terms" className="underline underline-offset-4 hover:text-white transition-colors">Terms &amp; Conditions</Link>
    <Link to="/security" className="underline underline-offset-4 hover:text-white transition-colors">Security &amp; Retention</Link>
    <Link to="/contact" className="underline underline-offset-4 hover:text-white transition-colors">Contact</Link>
  </div>
);

export const PncFooter = () => (
  <footer data-testid="pnc-footer" className="relative z-10 border-t border-[var(--line)] bg-[#111111] mt-20">
    <div className="max-w-6xl mx-auto px-6 pt-14 pb-10 grid grid-cols-1 md:grid-cols-3 gap-12">
      <div>
        <img src="/pnc-logo-white.png" alt="PNC UNIQUE LTD" className="h-16 w-auto mb-2" />
        <p className="text-[10px] uppercase tracking-[0.28em] text-[var(--muted)] font-semibold mb-8">
          Contract E-Signature Portal
        </p>
        <p className="text-sm text-[var(--muted)] mb-4">Registered in England and Wales</p>
        <div className="text-sm text-[var(--muted)] leading-7">
          {ADDRESS_LINES.map((l) => <p key={l}>{l}</p>)}
        </div>
        <p className="text-sm text-[var(--muted)] mt-4">ICO Registration <span className="text-[var(--text)] font-semibold">ZB865873</span></p>
        <div className="text-sm text-[var(--muted)] mt-4 space-y-2">
          <p><a href="mailto:admin@pncunique.com" className="hover:text-white transition-colors">admin@pncunique.com</a></p>
          <p><a href="tel:03330905024" className="hover:text-white transition-colors">0333 090 5024</a></p>
          <p><a href="https://www.pncunique.com" target="_blank" rel="noreferrer" className="hover:text-white transition-colors">www.pncunique.com</a></p>
        </div>
      </div>

      <div>
        <p className="field-label mb-6">About</p>
        <ul className="space-y-4 text-sm text-[var(--muted)]">
          <li>
            <a data-testid="footer-link-about" href="https://www.pncunique.com" target="_blank" rel="noreferrer" className="hover:text-white transition-colors">About PNC UNIQUE LTD</a>
          </li>
          <li>
            <Link data-testid="footer-link-contact" to="/contact" className="hover:text-white transition-colors">Contact HR</Link>
          </li>
          <li>
            <a data-testid="footer-link-website" href="https://www.pncunique.com" target="_blank" rel="noreferrer" className="hover:text-white transition-colors">Company website</a>
          </li>
        </ul>
      </div>

      <div>
        <p className="field-label mb-6">Legal</p>
        <ul className="space-y-4 text-sm text-[var(--muted)]">
          <li>
            <Link data-testid="footer-link-privacy" to="/privacy" className="hover:text-white transition-colors">Privacy Notice</Link>
          </li>
          <li>
            <Link data-testid="footer-link-terms" to="/terms" className="hover:text-white transition-colors">Terms &amp; Conditions</Link>
          </li>
          <li>
            <Link data-testid="footer-link-security" to="/security" className="hover:text-white transition-colors">Security &amp; Retention</Link>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-[var(--line)]">
      <p className="max-w-6xl mx-auto px-6 py-6 text-center text-xs text-[var(--muted)]">
        &copy; {new Date().getFullYear()} PNC UNIQUE LTD. All rights reserved.
      </p>
    </div>
  </footer>
);

export default PncFooter;
